import * as Yup from 'yup'

const validationSchema = Yup.object().shape({
    numero_documento: Yup.string().required('El numero de documento es obligatorio'),
    password: Yup.string().required('La contraseña es obligatoria')
})

export default validationSchema